import { useEffect } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { loginRequest, AUTH_REDIRECT_ATTEMPT_KEY } from "authConfig";

// Throttle auto-redirects so a deterministic auth failure can't melt into a
// tight full-page redirect loop, while still retrying on later reloads.
const REDIRECT_THROTTLE_MS = 15000;

// Rendered by MsalAuthenticationTemplate when the login flow fails (e.g. an
// expired session). We always redirect to Azure to re-authenticate rather than
// showing an error/retry screen — a page reload alone only re-runs the failing
// silent auth.
const AuthError = () => {
  const { instance, inProgress } = useMsal();

  useEffect(() => {
    if (inProgress !== InteractionStatus.None) {
      return;
    }
    const lastAttempt = Number(
      sessionStorage.getItem(AUTH_REDIRECT_ATTEMPT_KEY) ?? 0
    );
    if (Date.now() - lastAttempt < REDIRECT_THROTTLE_MS) {
      return;
    }
    sessionStorage.setItem(AUTH_REDIRECT_ATTEMPT_KEY, String(Date.now()));
    instance.loginRedirect(loginRequest).catch(() => {});
  }, [inProgress, instance]);

  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 2,
      }}
    >
      <CircularProgress size={32} />
      <Typography variant="body2" color="text.secondary">
        Redirecting to sign-in…
      </Typography>
    </Box>
  );
};

export default AuthError;
